import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { SocketService } from 'src/app/services/app/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { NOTIFICATION_ROUTES } from 'src/app/utils/notification-routes';

@UntilDestroy()
@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.css']
})
export class NotificationModalComponent implements OnInit {
  @Output() closeModal = new EventEmitter<void>();

  notifications: any[] = [];
  unreadCount = 0;
  loading = false;

  constructor(
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.sharedDataService.getUnreadNotificationCount()
      .pipe(untilDestroyed(this))
      .subscribe(count => this.unreadCount = count);

    this.getNotifications();

    // new notification arrives while the list is open
    this.socketService.addListener(Events.NOTIFICATION)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data?.id && !this.notifications.some(n => (n.id || n._id) === data.id)) {
          this.notifications = [data, ...this.notifications];
        }
      });
  }

  getNotifications() {
    this.loading = !this.notifications.length;
    this.sharedDataService
      .getNotifications({ sortBy: 'createdAt:desc', time: [moment().startOf('day').toISOString(), moment().endOf('day').toISOString()] })
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data: any) => {
          this.notifications = data?.results || [];
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
  }

  trackById(index: number, notification: any) {
    return notification.id || notification._id;
  }

  get hasUnread(): boolean {
    return this.notifications.some(n => !n.isRead);
  }

  onMarkAllAsRead() {
    this.sharedDataService.markAllNotificationsAsRead()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.notifications.forEach(n => n.isRead = true);
          this.sharedDataService.setUnreadNotificationCount(0);
        }
      });
  }

  onNotificationClick(notification: any) {
    this.markAsRead(notification);
    const route = NOTIFICATION_ROUTES[notification?.type];
    if (route) {
      this.router.navigate([route]);
    }
    this.closeModal.emit();
  }

  markAsRead(notification: any) {
    if (!notification || notification.isRead) return;
    notification.isRead = true;
    this.sharedDataService.decrementUnreadNotificationCount(1);
    // not tied to untilDestroyed: the dropdown closes right after a click and must not cancel the request
    this.sharedDataService.markNotificationAsRead(notification.id || notification._id).subscribe({ error: () => { } });
  }

  viewAll() {
    this.router.navigate(['notifications']);
    this.closeModal.emit();
  }

  getRelativeTime(date: any): string {
    return date ? moment(date).fromNow() : '';
  }
}
